import { Color, Point } from "../../../../../domain/drawing";

export class LineInformation {
  color: Color;
  points: Point[];
}
